import Swiper from 'swiper'
import { A11y } from 'swiper/modules';

import 'swiper/css/pagination'

let swiperInstance = false

Swiper.use([A11y])

const mediaQuery = window.matchMedia('(max-width:1150px)')

function handleResizeChange (e) {
    // Check if the media query is true
    if (e.matches) {
        if (document.querySelector('[data-posts-slider]')) {
            swiperInstance = new Swiper('[data-posts-slider]', {
                slidesPerView: 1.05,
                spaceBetween: 32,
                breakpoints: {
                    650: {
                        slidesPerView: 2.2
                    }
                }
            })

            return
        }
    }

    if (swiperInstance) swiperInstance.destroy(true, true)
}

// Register event listener
mediaQuery.addListener(handleResizeChange)

// Initial check
handleResizeChange(mediaQuery)
